<template lang="pug">
  .point(
    :style="{'left': `${pointer.coordinates.x}%`, 'top': `${pointer.coordinates.y}%`}"
  )
    span {{ pointer.value }}
    v-icon.point__delete(@click="$emit('delete')") mdi-close
</template>

<script>
export default {
  props: {
    pointer: {
      type: Object,
      required: true,
    }
  }
}
</script>

<style lang="scss" scoped>

.point{
  transition: .2s;
  width: 30px;
  height: 30px;
  background-color: $primar-color-light;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  position: absolute;
  border: 2px solid white;
  transform: translateX(-50%) translateY(-50%);

  &__delete{
    cursor: pointer;
    position: absolute;
    width: 15px;
    height: 15px;
    font-size: 12px;
    right: -7.5px;
    top: -7.5px;
    background: $log-default;
    border-radius: 50%;
    color: white;
    line-height: 15px;
  }

  &:before{
    content: "";
    position: absolute;
    top: -3px;
    left: -3px;
    right: -3px;
    bottom: -3px;
    border: 2px solid $primar-color-light;
    border-radius: 50%;
  }
}

</style>
